/**
 * This is an attempt to abstract the complexities of our autocomplete plugins from netx.view
 * It became even more neccessary with the new version of select2 (which is very different but I think it is acutally a trully usable plugin finally)
 * The important thing is that now all autocomplete plugins can be self contained and our API can be agnostic
 * @class
 * @param {object} plugins Additonal plugin support
 * @todo Document the plugins object and what it has to return and why
 */
import Rpc from 'core-libs/backbone.rpc';
import {completions as autocompletions} from '@netx/core-app/properties/autocomplete';

// Create and provide RPC with our api url
var rpc = new Rpc();

/**
 * Makes the inquery to the server and returns results
 * It only cares about the plugin to get the return type method
 * @method
 * @private
 * @param {string}    completion Completion type (category, asset, user, etc)
 * @param {string}    q          Search string
 * @param {object}    extra      Extra data to return with results
 * @param {object}    opts       Options to pass along (has the plugin name)
 * @param {Netx.View} view       View that contains the autocomplete
 */
export const inquiry = function (completion, q, extra, opts, view) {
	var d = new $.Deferred();

	//var plg = plugins[opts.plugin];

	// our completion
	var c = autocompletions[completion];
	if (_.isFunction(c)) c = c(opts);

	let sh = opts.stringHandler;
	// success handler
	switch (c.return) {
		// TODO: this is a hack until we can get all the user auto lists using the new react one
		// we have updated the return from the server to move away from lvbs - in the mean time
		// we will just convert the data to an lvb format to save ourselves from legacy wrangling
		case 'userAutoListItemToLvb':
			sh = (data) => {
				return data.map((d) => {
					return {id: d.id.toString(), text: d.name};
				});
			};
			break;
		case 'lvb':
			sh = opts.LVBHandler;
			break;
		case 'inb':
			sh = opts.INBHandler;
			break;
	}

	if (!_.isFunction(sh)) {
		throw new Error(
			'Handler not defined or is invalid for autocomplete: ' +
				opts.plugin +
				' - "' +
				completion +
				'" : ' +
				(c.return == 'lvb' ? 'LVB' : 'String'),
		);
	}

	// It is always possible we got here with no query string
	// This kills the query
	if (q) {
		// Local data
		if (!_.isUndefined(c.data) && _.isUndefined(c.api)) {
			// convert the result into the right object with the handler sh(), then extend on any extra props in 'extra'
			q = q.toLowerCase();
			var r = sh(
				_.filter(c.data, function (d) {
					return d.label.toLowerCase().includes(q);
				}),
			);
			// Append any extra data to results
			if (!_.isUndefined(extra)) {
				r = _.map(r, function (d) {
					return _.extend(d, extra);
				});
			}
			// Give the view a chance to filter
			if (view && _.isFunction(view.filterAutocompleteResults)) {
				r = view.filterAutocompleteResults(r, completion, q);
			}
			return d.resolve(r);
		} else {
			// give rpc.query() an api endpoint name, some args, and a callback
			rpc.query(
				c.api,
				_.map(c.args, function (a) {
					return a == '_TERM_' ? q : a;
				}),
				function (reply) {
					// success handler
					// convert the result into the right object with the handler sh(), then extend on any extra props in 'extra'
					var r = sh(reply);
					// Append any extra data to results
					if (!_.isUndefined(extra)) {
						r = _.map(r, function (d) {
							return _.extend(d, extra);
						});
					}
					// Give the view a chance to filter
					if (view && _.isFunction(view.filterAutocompleteResults)) {
						r = view.filterAutocompleteResults(r, completion, q);
					}
					return d.resolve(r);
				},
			);
		}
	} else {
		d.resolve([]);
	}
	return d.promise();
};

export const getCompletion = function (opts) {
	switch (opts.completion) {
		case 'group':
			return {
				...opts,
				extra: {
					type: 'group',
				},
			};
		case 'tag':
			return {
				...opts,
				completion: 'tag',
				tags: true,
			};
		case 'user':
		case 'users':
			return {
				...opts,
				completion: 'user',
				extra: {
					type: 'user',
				},
			};
		case 'user/group': // TODO: rename userOrGroup
		case 'userOrGroup':
			return {
				...opts,
				completion: 'userOrGroup',
			};
	}

	return opts;
};

// detect data-autocomplete fields in this.el, and install automatically.
export const detectAutocomplete = function (el, type) {
	let autos = [
		...el.querySelectorAll(
			'[data-autocomplete]:not([data-autocomplete-added])',
		),
	];
	if (
		!autos.length &&
		el.getAttribute('data-autocomplete') &&
		!el.getAttribute('data-autocomplete-added')
	) {
		autos = [el];
	}

	return autos.filter((el) => {
		return type === el.getAttribute('data-autocomplete-plugin');
	});
};
